module.exports = __webpack_public_path__ + "static/media/calendar.92234e9b.svg";